﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import { CustomerSettingsPage } from "./Component";

//-------------------------------------------------------------------------------------
// Exports
//-------------------------------------------------------------------------------------

export default CustomerSettingsPage;
export * from "./Styles";
export * from "./Component";
